const restoreLegacyIds = () => {
    document.querySelectorAll('[data-defeat-the-monsters-instructions]').forEach((node) => {
        if (node.dataset.originalId) {
            node.id = node.dataset.originalId;
        }
    });

    document.querySelectorAll('[data-defeat-the-monsters-cage]').forEach((node) => {
        if (node.dataset.originalId) {
            node.id = node.dataset.originalId;
        }
    });
};

const parseGameConfig = (trigger) => {
    const rawConfig = trigger.dataset.gameConfig;

    if (!rawConfig) {
        return null;
    }

    try {
        return JSON.parse(rawConfig);
    } catch (error) {
        return null;
    }
};

const initDefeatTheMonstersGame = () => {
    const triggers = document.querySelectorAll('[data-defeat-the-monsters-start]');

    if (!triggers.length) {
        return;
    }

    triggers.forEach((trigger) => {
        const component = trigger.closest('[data-defeat-the-monsters-component]');
        const instructions = component ? component.querySelector('[data-defeat-the-monsters-instructions]') : null;
        const cage = component ? component.querySelector('[data-defeat-the-monsters-cage]') : null;

        if (instructions && !instructions.dataset.originalId) {
            instructions.dataset.originalId = instructions.id;
        }

        if (cage && !cage.dataset.originalId) {
            cage.dataset.originalId = cage.id;
        }

        trigger.addEventListener('click', () => {
            const gameConfig = parseGameConfig(trigger);
            const scriptUrl = gameConfig?.scriptUrl;

            if (!scriptUrl || document.querySelector(`script[data-defeat-the-monsters-script="${scriptUrl}"]`)) {
                return;
            }

            restoreLegacyIds();

            if (instructions) {
                instructions.id = 'game-instructions';
            }

            if (cage) {
                cage.id = 'monstercage';
            }

            window.DEFEAT_THE_MONSTERS_GAME_CONFIG = gameConfig;

            trigger.disabled = true;
            trigger.classList.add('is-loading');

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = scriptUrl;
            script.dataset.defeatTheMonstersScript = scriptUrl;

            script.addEventListener('load', () => {
                trigger.classList.remove('is-loading');
            });

            script.addEventListener('error', () => {
                trigger.disabled = false;
                trigger.classList.remove('is-loading');
            });

            document.body.appendChild(script);
        });
    });
};

export default initDefeatTheMonstersGame;
